import { FC } from 'react';
import { ContextProviderModel } from '@/lib/models/context-provider/context-provider.model';
import ContextProviderLink from '../context-provider-link';
import { UsageItem } from '../usage-card/helpers';
import UsageCard from '../usage-card';

interface Props {
  contexts: ContextProviderModel[];
}

const ContextProvidersCard: FC<Props> = ({ contexts }) => {
  const items = contexts.map((context) => {
    return {
      id: context.id,
      EntityLinkEl: <ContextProviderLink context={context} />,
    } as UsageItem;
  });

  return <UsageCard title="Data Sources" icon="doc-search" items={items} />;
};

export default ContextProvidersCard;
